import type { ExerciseEditorProps } from '@/types'
import OptionListEditor from '@/components/admin/OptionListEditor'

export default function MultipleChoiceEditor({ formData, setFormData, isViewMode }: ExerciseEditorProps) {
  return (
    <div className="space-y-4">
      <OptionListEditor formData={formData} setFormData={setFormData} isViewMode={isViewMode} />
    </div>
  )
}
